import React, { useState } from "react";
import "./pending-buying.styles.scss";

import BuyingPendingTable from "../buying-pending-table/buying-pending-table.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const PendingBuying = () => {
  const [searchValue, setSearchValue] = useState("");

  const handleChange = (event) => {
    setSearchValue(event.target.value);
  };

  return (
    <div className="pending-buying-container">
      <div className="search-container">
        <input placeholder="Search name, order no." onChange={handleChange} />
        <FontAwesomeIcon icon={["fa", "search"]} color="#3a4b3c" />
      </div>
      <BuyingPendingTable searchValue={searchValue} />
    </div>
  );
};
